var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDown = function SvgArrowDown(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "16px",
    viewBox: "0 0 25 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "19A1EF03-9D43-4312-87FE-0C84ACF76C56") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-218.000000, -563.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-Arrow-/-arrow-down-1",
    transform: "translate(218.000000, 563.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,15.5000018 C11.3382977,15.500819 10.7082987,15.2166089 10.271,14.72 L0.46,3.568 C-0.184929277,2.79940904 -0.0983289982,1.65652679 0.655049482,0.993890616 C1.40842796,0.331254441 2.55301564,0.391241837 3.233,1.129 L11.812,10.881 C11.8594692,10.9351547 11.9279857,10.9662092 12,10.9662092 C12.0720143,10.9662092 12.1405308,10.9351547 12.188,10.881 L20.767,1.129 C21.1977441,0.615663081 21.872739,0.375899922 22.5307895,0.502488996 C23.18884,0.62907807 23.7267052,1.10215895 23.9362535,1.7386688 C24.1458017,2.37517865 23.9941571,3.07525611 23.54,3.568 L13.732,14.716 C13.2939525,15.213811 12.6630996,15.4993703 12,15.5000018 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down.67bd4e5f0b593699cb283eefd726035b.svg";